import React from 'react';
import Header from "./components/Header.js";
import Footer from "./components/Footer.js";
import Sidebar from "./components/Sidebar.js";
import { ToastContainer } from 'react-toastify';
import FilterHeader from "./components/FilterHeader.js";
import ComposeBox from "./components/ComposeBox.js";
import CommonLoader from "./components/CommonLoader.js";
import { useLoading } from './context/LoadingContext';
import { Outlet, useLocation } from "react-router-dom";
import Notification from "./components/Notification.js";
import ResponsiveLayout from './components/ResponsiveLayout.js';


export const Loader = () => {
    const { isLoading } = useLoading();

    return (
        <div>
            {isLoading && <CommonLoader />}
        </div>
    );
};


export const HeaderWrapper = ({ children }) => {
    const location = useLocation();
    const isSettingsPage = location.pathname === '/settings';
    return (
        <>
            {!isSettingsPage && <FilterHeader />}
            {children}
        </>
    );
};

export const AppLayout = () => (
    <div className="parent-component-div-align container-fluid">
        <div className="row">
            <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-4 col-5 ps-0">
                <Sidebar />
            </div>
            <div className="col-xxl-10 col-lg-9 col-md-8 col-sm-8 col-7">
                <Header />
                <HeaderWrapper />
                <Outlet /> {/* This renders the child routes */}
            </div>
        </div>
        <ComposeBox />
        <ToastContainer pauseOnFocusLoss={false} draggable={true} />
        <Loader />
        <Notification />
    </div>
);



export const InitialLayout = () => (
    <>
        <div className="parent-initial-component min-vh-100">
            <Outlet />
            <ToastContainer pauseOnFocusLoss={false} />
            <Footer />
            <Loader />
        </div>
    </>
);